import { combineReducers } from "redux";
import ProgressReducer from "../Slices/loading";

export const rootReducer = combineReducers({
    ProgressReducer,
});
